import React from "react";

function CollapseIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="remove">
        <path
          id="Vector"
          d="M19 13.8838H5V11.8838H19V13.8838Z"
          fill="#0A829D"
        />
      </g>
    </svg>
  );
}

export { CollapseIcon };
